export default {
    data() {
        return {
            canSearchCep: true,
            statesOfBrazil: [
                { value: null, text: 'Selecione o Estado' },
                { value: 'AC', text: 'Acre' },
                { value: 'AL', text: 'Alagoas' },
                { value: 'AP', text: 'Amapá' },
                { value: 'AM', text: 'Amazonas' },
                { value: 'BA', text: 'Bahia' },
                { value: 'CE', text: 'Ceará' },
                { value: 'DF', text: 'Distrito Federal' },
                { value: 'ES', text: 'Espírito Santo' },
                { value: 'GO', text: 'Goiás' },
                { value: 'MA', text: 'Maranhão' },
                { value: 'MT', text: 'Mato Grosso' },
                { value: 'MS', text: 'Mato Grosso do Sul' },
                { value: 'MG', text: 'Minas Gerais' },
                { value: 'PA', text: 'Pará' },
                { value: 'PB', text: 'Paraíba' },
                { value: 'PR', text: 'Paraná' },
                { value: 'PE', text: 'Pernambuco' },
                { value: 'PI', text: 'Piauí' },
                { value: 'RJ', text: 'Rio de Janeiro' },
                { value: 'RN', text: 'Rio Grande do Norte' },
                { value: 'RS', text: 'Rio Grande do Sul' },
                { value: 'RO', text: 'Rondônia' },
                { value: 'RR', text: 'Roraima' },
                { value: 'SC', text: 'Santa Catarina' },
                { value: 'SP', text: 'São Paulo' },
                { value: 'SE', text: 'Sergipe' },
                { value: 'TO', text: 'Tocantins' }
            ],
        }
    },

    methods: {
        async searchCep(cep) {
            this.loading = true;

            await axios.get('/webservice-information/search-postal-code', {
                params: {
                    postal_code: cep
                }
            })
                .then((response) => {
                    let result = response.data;

                    this.form.city = result.city;
                    this.form.neighborhood = result.district;
                    this.form.number = result.number;
                    this.form.state = result.state;
                    this.form.street = result.street;
                })
                .catch(() => {
                    this.form.city = null;
                    this.form.neighborhood = null;
                    this.form.number = null;
                    this.form.state = null;
                    this.form.street = null;
                })
                .finally(() => this.loading = false)
        },

        async changeZipCodeInput(event) {
            let zipCode = event.target.value.replace('-', '');

            if (zipCode !== this.form.zip_code) {
                this.form.zip_code = zipCode;

                if (zipCode.length === 8 && this.canSearchCep) {
                    await this.searchCep(zipCode);
                }
            }
        },

        createLineAddress(number = null, street = null, neighborhood = null) {
            let fields = [];

            if (number) {
                fields.push(number);
            }

            if (street) {
                fields.push(street);
            }

            if (neighborhood) {
                fields.push(neighborhood);
            }

            return fields.join(', ');
        }
    }
}
